exports.install = function (Vue, options) {
    var base64 = require('js-base64')
    Vue.prototype.handelNewsRedirect = function (news){
        return news.external_link ? {name: 'home.news.link', params:{link:base64.Base64.encode(news.external_link)}} : {name: 'home.news.show', params:{id:news.id}}
    };

    Vue.prototype.handelAdsRedirect = function (ad){
        return ad.link_address ? {name: 'home.news.link', query:{link:ad.link_address}} : {}
    };
};
